import { render, staticRenderFns } from "./ed-section-folder-icon.vue?vue&type=template&id=25990014&scoped=true&"
import script from "./ed-section-folder-icon.ts?vue&type=script&lang=ts&"
export * from "./ed-section-folder-icon.ts?vue&type=script&lang=ts&"
import style0 from "./ed-section-folder-icon.scss?vue&type=style&index=0&id=25990014&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25990014",
  null
  
)

export default component.exports